import React, { useCallback, useEffect, useState } from "react";
import { BsStack } from "react-icons/bs";
import DocCollapse from "../sections/standards/DocCollapse";
import PageContainer from "../components/PageContainer";
import { getStandardData } from "../api/standard";
import DocAccordion from "../sections/standards/DocAccordion";
import { toImagePath } from "../utils/globalFunctions";

const bgImg = "/images/standards/bg-standards.jpeg";

const Standards = () => {
  const [docGroups, setDocGroups] = useState([]);
  const [pageData, setPageData] = useState(null);

  const getData = useCallback(async () => {
    try {
      const response = await getStandardData();

      setPageData(response);
    } catch (error) {
      console.warn("Error: ", error);
    }
  }, []);

  useEffect(() => {
    getData();
  }, [getData]);

  const displayContent1 = (
    <div className="mb-4">
      <h2 className="text-black text-xl font-bold  mb-4">
        {pageData?.trainingtitle}
      </h2>
      <div
        dangerouslySetInnerHTML={{
          __html: pageData?.trainingdetail,
          // __html: pageData?.trainingdetail?.replace(/\r|\n|\r\n/g, "<br>"),
        }}
      />
    </div>
  );

  const displayAdvisor = (
    <div className="max-w-3xl mx-auto">
      <div className="flex items-center gap-3 mb-3">
        <div
          className="rounded-md bg-[#E9EAF8] "
          style={{
            padding: "20px",
            height: "90px",
            width: "90px",
          }}
        >
          <div
            className="rounded-full p-4"
            style={{
              background: "#272974",
            }}
          >
            <BsStack size="20px" color="white" />
          </div>
        </div>
        <div
          style={{
            height: "90px",
          }}
          className="p-3 rounded-md bg-[#E9EAF8]"
        >
          <h2 className="text-base font-medium">{pageData?.servicetitle}</h2>
        </div>
      </div>

      {/* Content Section */}
      <div className="rounded-md p-5  bg-[#EDEDED]">
        <div
          dangerouslySetInnerHTML={{
            __html: pageData?.servicedetail,
          }}
        />
      </div>
    </div>
  );

  return (
    <PageContainer title={pageData?.title}>
      <section>
        <div className="container mx-auto mt-[-50px] max-w-[800px]">
          <div className="card bg-white shadow-xl mx-auto">
            <div className="card-body">
              <img
                src={
                  toImagePath(pageData?.banner?.path) ??
                  "/images/standards/standard-banner.png"
                }
                alt="CISA Cyber Hygiene"
                className="w-full h-auto mb-4"
              />

              <DocCollapse docGroups={pageData?.docgroup ?? []} />

              {displayContent1}
              {displayAdvisor}
            </div>
          </div>
        </div>
      </section>
    </PageContainer>
  );
};

export default Standards;
